export default __webpack_public_path__ + "static/media/fav-blue.8f9c8ec2.webp";